module.exports = __webpack_public_path__ + "static/oblakoder-home-5-427a206f213ef5a43f4b86aeb872a355.png";